import { render, staticRenderFns } from "./local_attrs.vue?vue&type=template&id=4ab76df4&scoped=true"
import script from "./local_attrs.vue?vue&type=script&lang=js"
export * from "./local_attrs.vue?vue&type=script&lang=js"
import style0 from "./local_attrs.vue?vue&type=style&index=0&id=4ab76df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab76df4",
  null
  
)

export default component.exports